import { useCallback } from "react";
import api from "../lib/api";
import logger from "../utils/logger";

export const usePoster = () => {
  return useCallback(async (url: string, data: any, method = "POST") => {
    try {
      const res = await api.request({ url, method, data });
      return res.data;
    } catch (error) {
      logger.error("API Error:", error);
      throw error;
    }
  }, []);
};
